import SensynUI from '@sensyn-robotics/sensyn-ui-vue3';
import { createVuetify } from 'vuetify';
import { defineNuxtPlugin } from '#imports';

export default defineNuxtPlugin((nuxtApp) => {
  const config = SensynUI.vuetifyOptions;
  if (config.locale) {
    // `window ? ...` は「window が常に truthy」なので 'ja' 側が死枝になり、
    // かつ window 自体が未定義の文脈では ReferenceError になる書き方だった。
    // 本アプリは nuxt.config.ts で ssr: false のため実害は出ていなかったが、
    // 存在判定は typeof で行うのが正しい。
    config.locale.locale =
      typeof window !== 'undefined' ? window.navigator.language.split('-')[0] : 'ja';
    config.locale.fallback = 'ja';
  }
  const vuetify = createVuetify(config);

  nuxtApp.vueApp.use(SensynUI, {
    vuetify,
  });
});
